import React from 'react'
import {
  Box,
  Button,
  Card,
  InlineGrid,
  Layout,
  Text,
} from '@shopify/polaris'
import { useTranslation } from 'react-i18next'

function JobsSection() {
  const { t } = useTranslation()

  return (
    <Layout.AnnotatedSection
      title={t('SettingsPage.Sections.Jobs.title')}
      description={t('SettingsPage.Sections.Jobs.description')}
    >
      <Card padding={'0'}>
        <Box padding={'400'}>
          <Text as="strong">{t('SettingsPage.Sections.Jobs.heading')}</Text>
          <InlineGrid columns={'1fr auto'} gap={'100'} alignItems="center">
            <Text>{t('SettingsPage.Sections.Jobs.subHeading')}</Text>
            <Button url="/settings/jobs">
              {t('SettingsPage.Sections.Jobs.btnCta')}
            </Button>
          </InlineGrid>
        </Box>
      </Card>
    </Layout.AnnotatedSection>
  )
}

export default JobsSection